import { baseUrl } from "../utils/baseUrl";
import jwtInterceoptor from "./autorizacao/jwt-interceptor";
import axios from "axios";

class ServicosColaborador {
    create(colaborador) {
        return jwtInterceoptor.post(`${baseUrl}/colaborador`, colaborador)
    }
    listarTodos(){
        return jwtInterceoptor.get(`${baseUrl}/colaborador`)
    }
    listarUm(id){
        return jwtInterceoptor.get(`${baseUrl}/colaborador/${id}`)
    }
    editar(id, cargo){
        return jwtInterceoptor.put(`${baseUrl}/colaborador/${id}`, cargo)
    }
    aceitarTermo(id, aceite){
        return jwtInterceoptor.put(`${baseUrl}/colaborador/${id}`, aceite)
    }
    deletar(id){
        return jwtInterceoptor.get(`${baseUrl}/colaborador/fakeDelete/${id}`)
    }
    getTotalPontos(id){
        return jwtInterceoptor.get(`${baseUrl}/colaborador/totalPontos/${id}`)
    }
    getTotalPontosExternos(id){
        return jwtInterceoptor.get(`${baseUrl}/colaborador/totalPontosExternos/${id}`)
    }
    redefinirSenha(email){
        return axios.post(`${baseUrl}/colaborador/redefinir_senha`, email)
    }
    alterarSenha(id, senha){
        return jwtInterceoptor.put(`${baseUrl}/colaborador/${id}`,senha)
    }
    listarPontuacoes(){
        return jwtInterceoptor.get(`${baseUrl}/colaboradorPontos`);
    }
    listarPontuacoesExterna(){
        return jwtInterceoptor.get(`${baseUrl}/colaboradorPontosExternos`);
    }
}

export default new ServicosColaborador();